/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DeleteUserCustomFilterCommandFromJSON(json) {
    return DeleteUserCustomFilterCommandFromJSONTyped(json, false);
}
export function DeleteUserCustomFilterCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'customFilterTitle': !exists(json, 'customFilterTitle') ? undefined : json['customFilterTitle'],
    };
}
export function DeleteUserCustomFilterCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'customFilterTitle': value.customFilterTitle,
    };
}
